import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopOriginals from './ShopOriginals';

export const getShopOriginalsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: ShopOriginals,
});

